export function createAction(type, ...argNames) {
  return () => {
    const action = { type };
    argNames.forEach((arg, index) => {
      switch (index) {
      case 0:
        action.payload = arg();
        break;
      case 1:
        action.meta = arg();
        break;
      default:
        break;
      }
    });
    return action;
  };
}

export { createAction as default };